var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7751 11.0835L15.705 11.019C15.4603 10.8253 15.1131 10.8468 14.8913 11.0835L12.6251 13.5007L12.6248 7.55428L12.6192 7.46382C12.5778 7.13841 12.3163 6.88761 11.9998 6.88761L11.915 6.8937C11.61 6.93784 11.3748 7.21677 11.3748 7.55428L11.3751 13.5024L9.10786 11.083L9.03776 11.0184C8.79312 10.8247 8.44591 10.8462 8.22397 11.0828C7.97985 11.3431 7.97977 11.7652 8.22381 12.0256L11.5571 15.5825L11.6273 15.6471C11.8719 15.8408 12.2192 15.8193 12.4411 15.5826L15.7751 12.0263L15.8356 11.9515C16.0172 11.6905 15.997 11.3202 15.7751 11.0835ZM7.20818 3.33203C5.71241 3.33203 4.49985 4.62543 4.49985 6.22092V16.4431C4.49985 18.0386 5.71241 19.332 7.20818 19.332H16.7915C18.2873 19.332 19.4998 18.0386 19.4998 16.4431V6.22092C19.4998 4.62543 18.2873 3.33203 16.7915 3.33203H7.20818ZM5.74985 6.22092C5.74985 5.36181 6.40276 4.66536 7.20818 4.66536H16.7915C17.5969 4.66536 18.2498 5.36181 18.2498 6.22092V16.4431C18.2498 17.3023 17.5969 17.9987 16.7915 17.9987H7.20818C6.40276 17.9987 5.74985 17.3023 5.74985 16.4431V6.22092Z",
    fill: "#000095"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportFileIcon);
export default __webpack_public_path__ + "static/media/exportFile-icon.62d665fd896758dea4158e5569dca51c.svg";
export { ForwardRef as ReactComponent };